import constantURL from "./ConstantURL";

const ROLE_FAMILY_MEMBER = "FAMILYMEMBER";
const ROLE_CAREGIVER = "CAREGIVER";

export const getFamilyMemberFullName = (familyMemberInfo = {}) => {
  const directName = String(familyMemberInfo.fullName || familyMemberInfo.familyMemberName || "").trim();
  if (directName) {
    return directName;
  }

  return [familyMemberInfo.familyMemberFirstName || familyMemberInfo.firstName, familyMemberInfo.familyMemberLastName || familyMemberInfo.lastName]
    .map((part) => String(part || "").trim())
    .filter(Boolean)
    .join(" ");
};

export const loginWithEmailPassword = async ({ email, password }) => {
  const normalizedEmail = String(email || "").trim();
  const normalizedPassword = String(password ?? "");

  if (!normalizedEmail || !normalizedPassword) {
    return { success: false, message: "Email and password are required." };
  }

  try {
    const response = await fetch(constantURL.authLogin, {
      method: "POST",
      mode: "cors",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: normalizedEmail,
        password: normalizedPassword,
      }),
    });

    let data = null;
    try {
      data = await response.json();
    } catch {
      data = null;
    }

    if (!response.ok || data?.status !== "success" || !data?.data?.token) {
      return {
        success: false,
        message: data?.message || "Invalid email or password.",
      };
    }

    const { token, role, familyMemberInfo, caregiverInfo } = data.data;
    const normalizedRole = String(role || "").toUpperCase();

    if (normalizedRole === ROLE_FAMILY_MEMBER) {
      const normalizedFamilyMemberInfo = {
        ...(familyMemberInfo || {}),
        familyMemberName: getFamilyMemberFullName(familyMemberInfo),
      };

      return {
        success: true,
        role: "family",
        token,
        familyMemberInfo: normalizedFamilyMemberInfo,
        message: data.message || "",
      };
    }

    if (normalizedRole === ROLE_CAREGIVER) {
      return {
        success: true,
        role: "caregiver",
        token,
        caregiverInfo: caregiverInfo || {},
        message: data.message || "",
      };
    }

    return {
      success: false,
      message: data?.message || "Unsupported user role.",
    };
  } catch {
    return {
      success: false,
      message: "Unable to sign in. Please try again.",
    };
  }
};
